import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Note121Layer from "../components/Note121Layer";

const Note121Page = () => {
  return (
    <>
      <MasterLayout>
        <Note121Layer />
      </MasterLayout>
    </>
  );
};

export default Note121Page;
